import { PATH } from './const';
import { useApiCreate } from '../../../../../../lib/HttpService';
import { StubbornSessionConfiguration } from '../../../../../../application/business/StubbornConfiguration';

export const useEditionConfigurationSessionCreate = () => useApiCreate<StubbornSessionConfiguration>(PATH);
